import {Card, Col, Container, Row} from "react-bootstrap";
import {useState} from "react";
import {convertDescriptionPrefix, covertJobTitle} from "../service/jobutil";
import JobImageGallary from "./JobImageGallary";
import JobTimeline from "./JobTimeline";


export default function JobExpand(job) {
    const [images, setImages] = useState()

    return (<div>
        <Container fluid>
            <Row>
                <Col sm={6}>
                    <Card style={{textAlign: "left"}}>

                        <Card.Body>
                            <Card.Text>
                                <b>{covertJobTitle(job.data)}</b>
                            </Card.Text>
                            <Card.Text>
                                {convertDescriptionPrefix(job.data)}
                            </Card.Text>
                            <Card.Text>
                                {job.data.description}
                            </Card.Text>
                            <Card.Text>
                                {job.data.email}<br/>
                                {job.data.phone}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={6}>
                    <JobTimeline jobId={job.data.job_id || job.data.id}/>
                </Col>
            </Row>
            <Row>
                <JobImageGallary job={job.data}
                                 images={images}
                                 isReadOnly={true}
                                 setImages={setImages}/>

            </Row>

        </Container>


    </div>)

}
